import React from 'react';
import { Layout } from '../components/Layout';
import { Container } from '../components/ui/Container';
import { Mail, Phone, MapPin, Clock, MessageSquare, MessageCircle } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function ContactPage() {
  return <Layout data-id="element-195">
      <div className="bg-slate-50 py-16 border-b border-slate-200" data-id="element-196">
        <Container className="text-center" data-id="element-197">
          <h1 className="text-4xl font-bold text-slate-900 mb-6" data-id="element-198">Contact Us</h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-199">
            Have questions about our educational and consulting services? Reach
            out directly by phone or email — we're happy to help.
          </p>
        </Container>
      </div>

      <Container className="py-20" data-id="element-200">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-201">
          <div data-id="element-202">
            <h2 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-203">
              Get in Touch
            </h2>
            <p className="text-slate-600 mb-8 leading-relaxed" data-id="element-204">
              The best way to reach BRIXEN CREDIT LLC is by phone or email.
              Contact us directly and a specialist will be glad to discuss how
              our educational consulting services work.
            </p>

            <div className="space-y-6 mb-10" data-id="element-205">
              <a href="tel:7863763985" className="flex items-start group" data-id="element-206">
                <Phone className="h-6 w-6 text-blue-600 mr-4 mt-1" data-id="element-207" />
                <div data-id="element-208">
                  <h3 className="font-semibold text-slate-900" data-id="element-209">Phone</h3>
                  <p className="text-blue-600 group-hover:underline" data-id="element-210">
                    (786) 376-3985
                  </p>
                </div>
              </a>
              <a href="mailto:info@brixencredit.com" className="flex items-start group" data-id="element-211">
                <Mail className="h-6 w-6 text-blue-600 mr-4 mt-1" data-id="element-212" />
                <div data-id="element-213">
                  <h3 className="font-semibold text-slate-900" data-id="element-214">Email</h3>
                  <p className="text-blue-600 group-hover:underline" data-id="element-215">
                    info@brixencredit.com
                  </p>
                </div>
              </a>
              <div className="flex items-start" data-id="element-216">
                <MapPin className="h-6 w-6 text-blue-600 mr-4 mt-1" data-id="element-217" />
                <div data-id="element-218">
                  <h3 className="font-semibold text-slate-900" data-id="element-219">Office</h3>
                  <p className="text-slate-600" data-id="element-220">
                    BRIXEN CREDIT LLC
                    <br data-id="element-221" />
                    390 NE 191ST ST STE 8123
                    <br data-id="element-222" />
                    Miami, FL 33179
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-223">
                <Clock className="h-6 w-6 text-blue-600 mr-4 mt-1" data-id="element-224" />
                <div data-id="element-225">
                  <h3 className="font-semibold text-slate-900" data-id="element-226">
                    Business Hours
                  </h3>
                  <p className="text-slate-600" data-id="element-227">
                    Monday – Saturday, 9am – 9pm EST
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-228">
              <a href="https://wa.me/17863763985" target="_blank" rel="noopener noreferrer" className="flex-1" data-id="element-229">
                <Button className="w-full" size="lg" data-id="element-230">
                  <MessageCircle className="h-5 w-5 mr-2" data-id="element-231" />
                  Contact Us
                </Button>
              </a>
              <a href="mailto:info@brixencredit.com" className="flex-1" data-id="element-232">
                <Button variant="outline" className="w-full" size="lg" data-id="element-233">
                  <Mail className="h-5 w-5 mr-2" data-id="element-234" />
                  Email Us
                </Button>
              </a>
            </div>
          </div>

          {/* Chat With Us — reserved space for GHL A2P chat widget */}
          <div data-id="element-235">
            <div className="bg-slate-50 rounded-2xl border border-slate-200 p-8 h-full" data-id="element-236">
              <div className="flex items-center gap-3 mb-6" data-id="element-237">
                <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-238">
                  <MessageSquare className="h-5 w-5 text-blue-600" data-id="element-239" />
                </div>
                <h2 className="text-2xl font-bold text-slate-900" data-id="element-240">
                  Chat With Us
                </h2>
              </div>
              {/* GHL A2P Chat Widget will be embedded here */}
              <div id="ghl-chat-widget" className="min-h-[300px] flex items-center justify-center rounded-xl border border-dashed border-slate-300 bg-white text-center px-6" data-id="element-241">
                <p className="text-sm text-slate-500" data-id="element-242">
                  Our live chat will appear here shortly. For now, the fastest
                  way to reach us is by phone at{' '}
                  <a href="tel:7863763985" className="text-blue-600 underline" data-id="element-243">
                    (786) 376-3985
                  </a>{' '}
                  or email at{' '}
                  <a href="mailto:info@brixencredit.com" className="text-blue-600 underline" data-id="element-244">
                    info@brixencredit.com
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Layout>;
}